import React, { useState } from 'react';
import axios from '../config/axios';

const LoginPage = ({ onBack, onSignupLink, onLoginSuccess, showKidLoginFlow = false }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleUsernameChange = (val) => {
        setUsername(val);
        if (error) setError('');
    };

    const handlePasswordChange = (val) => {
        setPassword(val);
        if (error) setError('');
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/v1/auth/login', {
                username,
                password
            });
            // Handle successful login
            if (onLoginSuccess) {
                onLoginSuccess(response.data);
            }
        } catch (err) {
            setError('Login failed. Please check your credentials and try again.');
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <button className="btn-back" onClick={onBack}>← Back to Home</button>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <img
                        src="/dadbucks_logo_1.png"
                        alt="DadBucks Logo"
                        style={{ height: '64px', width: 'auto' }}
                    />
                </div>
                <h2>{showKidLoginFlow ? 'Welcome Back, Kid! 🎉' : 'DadBucks Parent Login'}</h2>
                <p className="subtitle">{showKidLoginFlow ? 'Sign in to see your chores and balance' : 'Manage your family\'s chores & rewards'}</p>
                <form onSubmit={handleLogin}>
                    <div className="input-group">
                        <label htmlFor="login-username">Username / Email</label>
                        <input
                            id="login-username"
                            type="text"
                            placeholder="Enter your email"
                            value={username}
                            onChange={(e) => handleUsernameChange(e.target.value)}
                            autoComplete="username"
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="login-password">Password</label>
                        <input
                            id="login-password"
                            type="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => handlePasswordChange(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    document.querySelector('.login-button').click();
                                }
                            }}
                            autoComplete="current-password"
                            required
                        />
                    </div>
                    {error && <p className="error-message" role="alert" aria-live="assertive">{error}</p>}
                    <button type="submit" className="login-button">Sign In</button>
                </form>
                <div className="login-footer">
                    Don't have an account? <span role="button" aria-label="Sign Up" onClick={onSignupLink}>Create one here</span>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;